import { useEffect, useState } from "react";
import { Grid, KpiCard } from "../../../../components";
import { OrdemServicoService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const ordemServicoService = new OrdemServicoService();

const defaultKpis = {
  osAbertas: 0,
  osAndamento: 0,
  osConcluidas: 0,
  osAtrasadas: 0,
  osPrazo: 0,
  taxaPrazo: 0,
  ticketMedio: 0,
  tempoMedioDias: 0,
  valorTotal: 0,
  variacao: null,
};

function MonitorOsKpis({ filtrosBody }) {
  const [kpis, setKpis] = useState(defaultKpis);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    buscarKpis();
  }, [filtrosBody]);

  async function buscarKpis() {
    setLoading(true);
    const result = await ordemServicoService.getRelatorioDashboardKpis(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setKpis(result.data || defaultKpis);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const variacao = kpis.variacao || {};

  const tempoLabel =
    kpis.tempoMedioDias >= 1
      ? `${kpis.tempoMedioDias.toFixed(1)} dias`
      : `${Math.round(kpis.tempoMedioDias * 24)}h`;

  const cards = [
    {
      title: "O.S Abertas",
      value: kpis.osAbertas,
      icon: "ph-folder-open",
      color: "#1976d2",
      variation: variacao.osAbertas,
    },
    {
      title: "O.S em Andamento",
      value: kpis.osAndamento,
      icon: "ph-arrow-circle-right",
      color: "#f57c00",
      variation: variacao.osAndamento,
    },
    {
      title: "O.S Concluídas",
      value: kpis.osConcluidas,
      icon: "ph-check-circle",
      color: "#388e3c",
      variation: variacao.osConcluidas,
    },
    {
      title: "O.S Atrasadas",
      value: kpis.osAtrasadas,
      icon: "ph-warning-circle",
      color: "#d32f2f",
      variation: variacao.osAtrasadas,
      invert: true,
    },
    {
      title: "Taxa no Prazo",
      value: `${(kpis.taxaPrazo || 0).toFixed(1)}%`,
      icon: "ph-gauge",
      color: "#0288d1",
      variation: variacao.taxaPrazo,
    },
    {
      title: "Ticket Médio",
      value: formatPrice(kpis.ticketMedio),
      icon: "ph-currency-dollar",
      color: "#7b1fa2",
      variation: variacao.ticketMedio,
    },
    {
      title: "Tempo Médio de Execução",
      value: tempoLabel,
      icon: "ph-clock",
      color: "#0288d1",
      variation: variacao.tempoMedioDias,
      invert: true,
    },
    {
      title: "Valor Total O.S",
      value: formatPrice(kpis.valorTotal),
      icon: "ph-money",
      color: "#00796b",
      variation: variacao.valorTotal,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 1 }}>
      {cards.map((card) => (
        <Grid key={card.title} item xs={6} md={3}>
          <KpiCard
            title={card.title}
            value={card.value}
            icon={card.icon}
            color={card.color}
            variation={card.variation}
            invert={card.invert}
            loading={loading}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default MonitorOsKpis;
